<!-- Dialog principal de detalhes.
     `closable` cai para false quando ha alteracoes pendentes: Escape e clique
     fora sairiam sem perguntar (o PrimeNG amarra os dois a `closable`). O X do
     header e o "Fechar" do rodape seguem disponiveis e levam a pergunta. -->
<p-dialog
  [visible]="visivel"
  (onHide)="onHide()"
  [modal]="true"
  [closable]="!temPendencias()"
  [style]="{ width: '68rem', maxWidth: '95vw' }"
  [breakpoints]="{ '960px': '95vw' }"
  styleClass="dialog-wave-redesign dialog-pedido-detalhe"
  [showHeader]="false">

  <!-- Wave Header customizado -->
  <div class="dialog-wave-header"
       *ngIf="pedido"
       [style.background]="getBackgroundEstado(pedido.estadoDePedido)">
    <div class="wave-content">
      <div class="wave-icon">
        <i [class]="getIconeEstado(pedido.estadoDePedido)" aria-hidden="true"></i>
      </div>
      <div class="wave-text">
        <h2>{{ texts?.labels?.pedido }} #{{ pedido.codigoDePedido }}</h2>
        <p>{{ texts?.labels?.cliente }}: {{ pedido.nomeCliente || '-' }}</p>
      </div>
      <button pButton
              type="button"
              icon="pi pi-whatsapp"
              class="p-button-rounded p-button-text wave-action-btn"
              [pTooltip]="texts?.botoes?.whatsapp"
              tooltipPosition="bottom"
              (click)="onAbrirWhatsApp()"
              *ngIf="pedido?.telefone">
      </button>
      <button pButton
              type="button"
              icon="pi pi-share-alt"
              class="p-button-rounded p-button-text wave-action-btn"
              [pTooltip]="texts?.botoes?.compartilhar_pedido"
              tooltipPosition="bottom"
              (click)="onCompartilharPedido()">
      </button>
      <button pButton
              type="button"
              icon="pi pi-print"
              class="p-button-rounded p-button-text wave-action-btn"
              [pTooltip]="texts?.botoes?.imprimir"
              tooltipPosition="bottom"
              (click)="onImprimirPedidoClick()">
      </button>
      <button pButton
              type="button"
              icon="pi pi-times"
              class="p-button-rounded p-button-text wave-close-btn"
              (click)="onHide()">
      </button>
    </div>
    <div class="wave-shape">
      <svg viewBox="0 0 1440 40" preserveAspectRatio="none">
        <path d="M0,20 C360,40 1080,0 1440,20 L1440,40 L0,40 Z" fill="white"/>
      </svg>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="dialog-loading">
    <p-progressSpinner strokeWidth="3" animationDuration="1s"></p-progressSpinner>
  </div>

  <!-- Conteudo do pedido -->
  <div *ngIf="!loading && pedido" class="dialog-body">

    <!-- Informacoes gerais -->
    <div class="info-grid">
      <div class="info-item">
        <span class="info-label">{{ texts?.labels?.estado }}</span>
        <span class="estado-badge"
              [style.background]="getBackgroundEstado(pedido.estadoDePedido)"
              [style.color]="'white'">
          <i [class]="getIconeEstado(pedido.estadoDePedido)" aria-hidden="true"></i>
          {{ getEstadoLabel(pedido.estadoDePedido) }}
        </span>
      </div>

      <div class="info-item">
        <span class="info-label">{{ texts?.labels?.data }}</span>
        <span class="info-value">{{ formatarDataExibicao(pedido.emissao) }}</span>
      </div>

      <div class="info-item" *ngIf="pedido.telefone">
        <span class="info-label">{{ texts?.labels?.telefone }}</span>
        <span class="info-value">{{ pedido.telefone }}</span>
      </div>

      <div class="info-item" *ngIf="pedido.nomeVendedor">
        <span class="info-label">{{ texts?.labels?.vendedor || 'Vendedor' }}</span>
        <span class="info-value">{{ pedido.nomeVendedor }}</span>
      </div>

      <div class="info-item" *ngIf="pedido.numeroMesa != null">
        <span class="info-label">{{ texts?.labels?.mesa }}</span>
        <span class="info-value">{{ pedido.numeroMesa }}</span>
      </div>

      <div class="info-item" *ngIf="pedido.numeroComanda != null">
        <span class="info-label">{{ texts?.labels?.comanda }}</span>
        <span class="info-value">{{ pedido.numeroComanda }}</span>
      </div>

      <div class="info-item" *ngIf="ehDelivery()">
        <span class="info-label">{{ texts?.labels?.frete }}</span>
        <span class="info-value">{{ (pedido.valorFrete || 0) | moedaSimbolo: moedaPadrao : digitsMoeda : localeMoeda }}</span>
      </div>

      <div class="info-item full-width" *ngIf="pedido.observacao">
        <span class="info-label">{{ texts?.labels?.observacao }}</span>
        <span class="info-value">{{ pedido.observacao }}</span>
      </div>
    </div>

    <!-- Endereco de entrega (apenas para pedidos DELIVERY com endereco preenchido) -->
    <div class="endereco-entrega-section"
         *ngIf="pedido.enderecoDeEntrega">
      <h3 class="section-title">
        <i class="pi pi-map-marker" aria-hidden="true"></i>
        {{ texts?.labels?.endereco_entrega || 'Dirección de Entrega' }}
      </h3>
      <div class="endereco-entrega-body">
        <span class="endereco-entrega-linha">{{ pedido.enderecoDeEntrega }}</span>
        <span class="endereco-entrega-linha" *ngIf="pedido.referenciaDeEntrega">
          <i class="pi pi-home" aria-hidden="true"></i>
          {{ texts?.labels?.referencia_entrega || 'Referencia' }}: {{ pedido.referenciaDeEntrega }}
        </span>
        <a *ngIf="pedido.latitudeEntrega && pedido.longitudeEntrega"
           [href]="'https://www.google.com/maps?q=' + pedido.latitudeEntrega + ',' + pedido.longitudeEntrega"
           target="_blank"
           rel="noopener noreferrer"
           class="endereco-mapa-link">
          <i class="pi pi-map" aria-hidden="true"></i>
          {{ texts?.labels?.ver_mapa || 'Ver en el mapa' }}
        </a>
      </div>
    </div>

    <!-- Tabela de itens -->
    <div class="itens-section">
      <!-- Busca em largura total ACIMA do titulo da tabela: no fim do modal o
           painel de resultados (appendTo="body") tapava o rodape de Valor
           Total / acoes. -->
      <div class="itens-section-header">
        <!-- Busca inline da venda reutilizada; a lupa abre a grade completa.
             Rotulo = para que; placeholder = como. Contador "Mostrando X de Y"
             desligado: persistia com o painel fechado e lia-se como contagem
             da tabela de itens. -->
        <!-- Venda fechada: o cliente ja pagou o total e a nota saiu. A tela diz o porque, em vez
             de simplesmente esconder o campo de adicionar item. -->
        <div class="aviso-pedido-pago" *ngIf="pedidoPagoAntecipadamente">
          <i class="pi pi-lock"></i>
          <span>{{ texts?.texts?.pedido_pago_bloqueado }}</span>
        </div>

        <div class="adicionar-item-busca" *ngIf="botoesDeAcaoVisiveis()">
          <label class="info-label adicionar-item-label" for="pedido-detalhe-item-busca">
            {{ texts?.labels?.adicionar_item_ao_pedido }}
          </label>
          <!-- Duas saidas, um destino: o componente separa "bipe de codigo de barras"
               (resultado unico cujo campo `barras` casa o termo) de "escolha visual",
               e emite em Outputs diferentes. No pedido as duas viram pendencia de
               adicao. Sem ouvir a segunda, o clique na sugestao de uma busca por
               codigo de barras so fechava o campo, sem adicionar o item. -->
          <app-operar-venda-item-busca
            inputId="pedido-detalhe-item-busca"
            [cfgMoeda]="cfgMoedaBusca"
            [disabled]="confirmandoAlteracoes"
            [exibirContadorDeResultados]="false"
            [exibirCodigoDoItem]="isColunaVisivel('codigo')"
            [exibirCodigoDeBarras]="isColunaVisivel('barras')"
            (itemEscolhido)="onItemBuscaEscolhido($event)"
            (itemEscolhidoViaCodigo)="onItemBuscaEscolhido($event)"
            (itemEscolhidoComQuantidade)="onItemBuscaEscolhidoComQuantidade($event)"
            (abrirLista)="abrirAdicionarItem()">
          </app-operar-venda-item-busca>
        </div>

        <div class="itens-titulo-linha">
          <h3 class="section-title">
            <i class="pi pi-list" aria-hidden="true"></i>
            {{ texts?.texts?.itens_do_pedido }}
          </h3>
          <app-column-selector
            [columns]="colunasItens"
            [storageKey]="STORAGE_KEY_COLUNAS"
            (columnsChange)="onColunasChange($event)">
          </app-column-selector>
        </div>
      </div>

      <div class="itens-table-container">
        <table class="itens-table" [class.pedido-encerrado]="pedidoEncerrado()">
          <thead>
            <tr>
              <th class="col-codigo" [hidden]="!isColunaVisivel('codigo')">{{ texts?.labels?.codigo }}</th>
              <th class="col-codigo" [hidden]="!isColunaVisivel('barras')">{{ texts?.labels?.codigo_de_barras }}</th>
              <th>{{ texts?.labels?.item }}</th>
              <th class="text-center">{{ texts?.labels?.quantidade }}</th>
              <th class="text-center">{{ texts?.labels?.saldo }}</th>
              <th class="text-right">{{ texts?.labels?.valor_unitario }}</th>
              <th class="text-right">{{ texts?.labels?.valor_total }}</th>
              <th class="text-center" *ngIf="podeCancelarItem()"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of pedido.itens"
                [class.item-sem-saldo]="item.saldo === 0"
                [class.item-faturado]="linhaFaturada(item)"
                [class.item-cancelado]="linhaCancelada(item)"
                [class.item-com-pendencia]="temIncrementoPendente(item)">
              <!-- Item do cardapio (mini shop) nao tem cadastro de item, entao nao tem codigo. -->
              <td class="col-codigo" [hidden]="!isColunaVisivel('codigo')">{{ item.item?.codigoItem ?? '-' }}</td>
              <td class="col-codigo" [hidden]="!isColunaVisivel('barras')">{{ item.item?.barras || '-' }}</td>
              <td>
                <span class="item-nome">{{ item.item?.nome || item.produtoCardapioNome || '-' }}</span>
                <span class="item-obs" *ngIf="item.variantesDePreco && item.variantesDePreco.length > 0">
                  <i class="pi pi-tag" aria-hidden="true"></i>
                  {{ texts?.labels?.variantes || 'Variantes' }}: {{ formatarVariantes(item.variantesDePreco, item.quantidade) }}
                </span>
                <span class="item-obs" *ngIf="item.modificadores && item.modificadores.length > 0">
                  <i class="pi pi-plus-circle" aria-hidden="true"></i>
                  {{ texts?.labels?.modificadores || 'Modificadores' }}: {{ formatarModificadores(item.modificadores, item.quantidade) }}
                </span>
                <span class="item-obs" *ngIf="item.observacao">
                  <i class="pi pi-comment" aria-hidden="true"></i>
                  {{ item.observacao }}
                </span>
              </td>
              <td class="text-center">
                {{ quantidadeExibida(item) }}
                <span class="marca-pendente" *ngIf="temIncrementoPendente(item)">
                  +{{ incrementoPendente(item) }}
                </span>
              </td>
              <td class="text-center col-saldo">
                <div *ngIf="podeAjustarQuantidade()" class="qty-adjuster">
                  <button pButton
                          type="button"
                          icon="pi pi-minus"
                          class="p-button-text p-button-sm p-button-danger"
                          [disabled]="!podeRemoverQuantidade(item)"
                          (click)="removeQuantidade(item)"
                          [attr.aria-label]="texts?.labels?.ajustar_quantidade">
                  </button>
                  <span class="qty-value">{{ saldoExibido(item) }}</span>
                  <!-- "+": some quando a linha ja tem faturamento e fica
                       inerte na linha toda cancelada (nao reabre saldo) -->
                  <button pButton
                          type="button"
                          icon="pi pi-plus"
                          class="p-button-text p-button-sm p-button-success"
                          *ngIf="!podeDuplicarItem(item)"
                          [disabled]="linhaCancelada(item)"
                          (click)="addQuantidade(item)"
                          [attr.aria-label]="texts?.labels?.ajustar_quantidade">
                  </button>
                  <!-- Duplicar: substitui o "+" na linha ja faturada -->
                  <button pButton
                          type="button"
                          icon="pi pi-copy"
                          class="p-button-text p-button-sm btn-duplicar-item"
                          *ngIf="podeDuplicarItem(item)"
                          [disabled]="confirmandoAlteracoes"
                          (click)="duplicarItem(item)"
                          [attr.aria-label]="texts?.botoes?.duplicar_item"
                          [pTooltip]="texts?.botoes?.duplicar_item">
                  </button>
                </div>
                <span *ngIf="!podeAjustarQuantidade()">{{ saldoExibido(item) }}</span>
              </td>
              <td class="text-right">{{ item.valorUnitario | moedaSimbolo: moedaPadrao : digitsMoeda : localeMoeda }}</td>
              <td class="text-right font-bold">{{ valorTotalExibido(item) | moedaSimbolo: moedaPadrao : digitsMoeda : localeMoeda }}</td>
              <td class="text-center" *ngIf="podeCancelarItem()">
                <button pButton
                        type="button"
                        icon="pi pi-times-circle"
                        class="p-button-danger p-button-text p-button-sm p-button-rounded"
                        [pTooltip]="texts?.botoes?.cancelar_item"
                        (click)="abrirDialogCancelarItem(item)"
                        *ngIf="item.saldo > 0">
                </button>
              </td>
            </tr>

            <!-- Itens escolhidos e ainda nao confirmados: entram como linhas
                 novas, marcadas, e saem daqui pelo "x" da propria linha. -->
            <tr *ngFor="let pendencia of pendenciasDeAdicao" class="linha-pendente">
              <td class="col-codigo" [hidden]="!isColunaVisivel('codigo')">{{ pendencia.codigoItem ?? '-' }}</td>
              <td class="col-codigo" [hidden]="!isColunaVisivel('barras')">{{ pendencia.barras || '-' }}</td>
              <td>
                <span class="item-nome">{{ pendencia.nome }}</span>
                <span class="item-obs" *ngIf="pendencia.variantesDePreco && pendencia.variantesDePreco.length > 0">
                  <i class="pi pi-tag" aria-hidden="true"></i>
                  {{ texts?.labels?.variantes || 'Variantes' }}: {{ formatarVariantes(pendencia.variantesDePreco) }}
                </span>
                <span class="item-obs" *ngIf="pendencia.modificadores && pendencia.modificadores.length > 0">
                  <i class="pi pi-plus-circle" aria-hidden="true"></i>
                  {{ texts?.labels?.modificadores || 'Modificadores' }}: {{ formatarModificadores(pendencia.modificadores) }}
                </span>
                <span class="item-obs" *ngIf="pendencia.observacao">
                  <i class="pi pi-comment" aria-hidden="true"></i>
                  {{ pendencia.observacao }}
                </span>
                <span class="etiqueta-pendente">
                  <i class="pi pi-clock" aria-hidden="true"></i>
                  {{ texts?.labels?.pendente || 'Pendiente' }}
                </span>
              </td>
              <td class="text-center">{{ pendencia.quantidade }}</td>
              <td class="text-center col-saldo">
                <div class="qty-adjuster">
                  <button pButton
                          type="button"
                          icon="pi pi-minus"
                          class="p-button-text p-button-sm p-button-danger"
                          [disabled]="confirmandoAlteracoes"
                          (click)="removerUmaUnidadeDaPendencia(pendencia)"
                          [attr.aria-label]="texts?.labels?.ajustar_quantidade">
                  </button>
                  <span class="qty-value">{{ pendencia.quantidade }}</span>
                  <button pButton
                          type="button"
                          icon="pi pi-plus"
                          class="p-button-text p-button-sm p-button-success"
                          [disabled]="confirmandoAlteracoes"
                          (click)="acumularUmaUnidadeNaPendencia(pendencia)"
                          [attr.aria-label]="texts?.labels?.ajustar_quantidade">
                  </button>
                </div>
              </td>
              <td class="text-right">{{ pendencia.valorUnitario | moedaSimbolo: moedaPadrao : digitsMoeda : localeMoeda }}</td>
              <td class="text-right font-bold">
                {{ pendencia.quantidade * pendencia.valorUnitario | moedaSimbolo: moedaPadrao : digitsMoeda : localeMoeda }}
              </td>
              <td class="text-center" *ngIf="podeCancelarItem()">
                <button pButton
                        type="button"
                        icon="pi pi-times-circle"
                        class="p-button-danger p-button-text p-button-sm p-button-rounded"
                        [disabled]="confirmandoAlteracoes"
                        [pTooltip]="texts?.botoes?.descartar_alteracoes"
                        (click)="removerPendenciaDeAdicao(pendencia)">
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Barra de confirmacao: so existe quando ha o que confirmar. Fica colada
           na tabela, onde as pendencias aparecem. -->
      <div class="pendencias-barra" *ngIf="temPendencias()">
        <div class="pendencias-resumo">
          <i class="pi pi-clock" aria-hidden="true"></i>
          <span>{{ texts?.texts?.alteracoes_pendentes }}</span>
        </div>
        <div class="pendencias-acoes">
          <button pButton
                  type="button"
                  [label]="texts?.botoes?.descartar_alteracoes"
                  icon="pi pi-undo"
                  class="p-button-text p-button-danger"
                  [disabled]="confirmandoAlteracoes"
                  (click)="descartarAlteracoes()">
          </button>
          <button pButton
                  type="button"
                  [label]="(texts?.botoes?.confirmar_alteracoes || 'Confirmar') + ' (' + totalDeUnidadesPendentes() + ')'"
                  icon="pi pi-check"
                  class="p-button-success"
                  [disabled]="confirmandoAlteracoes"
                  [loading]="confirmandoAlteracoes"
                  (click)="confirmarAlteracoes()">
          </button>
        </div>
      </div>

      <!-- Resumo dos itens -->
      <div class="itens-resumo" *ngIf="pedido.itens && pedido.itens.length > 0">
        <div class="resumo-row">
          <span>{{ texts?.labels?.qtd_itens }}:</span>
          <span>{{ getTotalQuantidade() }}</span>
        </div>
        <div class="resumo-row">
          <span>{{ texts?.labels?.saldo }}:</span>
          <span>{{ getTotalSaldo() }}</span>
        </div>
        <div class="resumo-row">
          <span>{{ texts?.labels?.qtd_cancelada }}:</span>
          <span>{{ getTotalCancelado() }}</span>
        </div>
        <div class="resumo-row">
          <span>{{ texts?.labels?.qtd_faturada }}:</span>
          <span>{{ getTotalFaturado() }}</span>
        </div>
      </div>
    </div>

    <!-- Notas vinculadas -->
    <div class="notas-section" *ngIf="pedido.notaIds && pedido.notaIds.length > 0">
      <h3 class="section-title">
        <i class="pi pi-file" aria-hidden="true"></i>
        {{ texts?.labels?.notas_vinculadas || 'Notas Fiscais' }}
      </h3>
      <div class="notas-chips">
        <span class="nota-chip"
              *ngFor="let notaId of pedido.notaIds"
              (click)="onNotaClick(notaId)"
              role="button"
              tabindex="0"
              (keydown.enter)="onNotaClick(notaId)">
          <i class="pi pi-file" aria-hidden="true"></i>
          {{ texts?.labels?.nota || 'Nota' }} #{{ notaId }}
        </span>
      </div>
    </div>

  </div>

  <!-- Valor total: faixa fixa no rodape do dialog, sempre visivel
       (fora do .dialog-body que rola). -->
  <div class="valor-total-bar" *ngIf="!loading && pedido" [class.tem-pendencias]="temPendencias()">
    <span class="valor-total-label">
      {{ texts?.labels?.valor_total }}
      <span class="valor-total-aviso" *ngIf="temPendencias()">
        {{ texts?.texts?.inclui_pendentes }}
      </span>
    </span>
    <span class="valor-total-value">{{ valorTotalProjetado() | moedaSimbolo: moedaPadrao : digitsMoeda : localeMoeda }}</span>
  </div>

  <!-- Footer com acoes -->
  <!-- Ordem do rodape (FORM_UI secao 2): acao destrutiva isolada na ponta
       esquerda — longe do "Fechar", cujo rotulo e quase sinonimo — depois o
       secundario, e a acao principal na ponta direita. -->
  <div *ngIf="!loading && pedido && botoesDeAcaoVisiveis()" class="dialog-footer">
    <!-- Cancelar pedido: destrutivo, isolado a esquerda -->
    <button pButton
            type="button"
            [label]="texts?.botoes?.cancelar_pedido || texts?.botoes?.cancelar"
            icon="pi pi-times-circle"
            class="p-button-danger p-button-outlined botao-destrutivo"
            [disabled]="acoesBloqueadasPorPendencias()"
            [pTooltip]="acoesBloqueadasPorPendencias() ? texts?.tooltips?.confirme_alteracoes_pendentes : null"
            (click)="onCancelarPedido()">
    </button>

    <!-- Fechar dialogo (secundario) -->
    <button pButton
            type="button"
            [label]="texts?.botoes?.fechar"
            icon="pi pi-times"
            class="p-button-secondary"
            (click)="onHide()">
    </button>

    <!-- Botao Estados -->
    <button *ngIf="temEstadosDisponiveis()"
            pButton
            type="button"
            icon="pi pi-arrow-right-arrow-left"
            [label]="texts?.botoes?.estados || 'Estados'"
            class="p-button-outlined botao-estados"
            [disabled]="acoesBloqueadasPorPendencias()"
            [pTooltip]="acoesBloqueadasPorPendencias() ? texts?.tooltips?.confirme_alteracoes_pendentes : null"
            (click)="dialogEstadosVisivel = true">
    </button>

    <!-- Botao Faturar (condicional) -->
    <button *ngIf="podeFaturar()"
            pButton
            type="button"
            icon="pi pi-dollar"
            [label]="texts?.botoes?.faturar || 'Faturar'"
            class="p-button-success"
            [disabled]="acoesBloqueadasPorPendencias()"
            [pTooltip]="acoesBloqueadasPorPendencias() ? texts?.tooltips?.confirme_alteracoes_pendentes : null"
            (click)="onFaturar()">
    </button>

    <!-- Botao Finalizar (quando pedido 100% faturado = ENTREGUE) -->
    <button *ngIf="podeFinalizar()"
            pButton
            type="button"
            icon="pi pi-check-circle"
            [label]="texts?.botoes?.finalizar || 'Finalizar'"
            class="p-button-outlined p-button-success"
            [disabled]="acoesBloqueadasPorPendencias()"
            [pTooltip]="acoesBloqueadasPorPendencias() ? texts?.tooltips?.confirme_alteracoes_pendentes : null"
            (click)="onFinalizar()">
    </button>
  </div>
</p-dialog>

<!-- Seletor de estados: componente compartilhado com o card da listagem -->
<app-pedido-estados-dialog
  [visivel]="dialogEstadosVisivel"
  [pedido]="pedido"
  [texts]="texts"
  (visivelChange)="dialogEstadosVisivel = $event"
  (acaoEscolhida)="onAcaoEstadoEscolhida($event.opcao)">
</app-pedido-estados-dialog>

<!-- Dialog de cancelar item (padrao wave — FORM_UI secao 3/4) -->
<p-dialog
  [(visible)]="dialogCancelarItemVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-times-circle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts?.botoes?.cancelar_item }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body cancelar-item-form" *ngIf="itemParaCancelar">
    <p>{{ texts?.texts?.confirmacao_cancelar_item }}</p>
    <p class="item-nome-cancelar">{{ itemParaCancelar.item?.nome || itemParaCancelar.produtoCardapioNome || '-' }}</p>
    <div class="quantidade-field">
      <label>{{ texts?.labels?.quantidade }}</label>
      <input type="number"
             pInputText
             [(ngModel)]="quantidadeCancelar"
             [min]="1"
             [max]="itemParaCancelar.saldo"
             class="w-full" />
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
            [label]="texts?.botoes?.fechar"
            class="p-button-secondary"
            (click)="dialogCancelarItemVisivel = false">
    </button>
    <button pButton
            [label]="texts?.botoes?.confirmar"
            severity="danger"
            icon="pi pi-times-circle"
            (click)="confirmarCancelarItem()">
    </button>
  </ng-template>
</p-dialog>

<!-- Pergunta ao fechar com alteracoes pendentes (padrao wave — FORM_UI 3/4).
     Sair calado jogaria fora o que o operador acabou de montar. -->
<p-dialog
  [(visible)]="dialogDescartarVisivel"
  [showHeader]="false"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  styleClass="dialog-wave-redesign"
  [style]="{ width: '30rem' }">

  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts?.texts?.titulo_descartar_alteracoes }}</h2>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>

  <div class="dialog-wave-body">
    <p>{{ texts?.texts?.confirmacao_descartar_alteracoes }}</p>
  </div>

  <ng-template pTemplate="footer">
    <button pButton
            type="button"
            [label]="texts?.botoes?.voltar_para_alteracoes"
            icon="pi pi-arrow-left"
            class="p-button-secondary"
            (click)="dialogDescartarVisivel = false">
    </button>
    <button pButton
            type="button"
            [label]="texts?.botoes?.descartar_alteracoes"
            severity="danger"
            icon="pi pi-trash"
            (click)="confirmarDescarteEFechar()">
    </button>
  </ng-template>
</p-dialog>

<!-- Dialog de adicionar item (grade de produtos) -->
<app-pedido-adicionar-item-dialog
  [visivel]="adicionarItemVisivel"
  [itens]="pedido?.itens || []"
  [pendencias]="pendenciasPorCatalogo"
  [moedaPadrao]="moedaPadrao"
  [localeMoeda]="localeMoeda"
  [digitsMoeda]="digitsMoeda"
  (visivelChange)="onAdicionarItemVisivelChange($event)"
  (produtoEscolhido)="onProdutoEscolhidoNaGrade($event)">
</app-pedido-adicionar-item-dialog>
